import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const eshops = (theme: Theme) => css`
  h2 {
    font-size: ${pxToRem(28)};
    max-width: ${width.modal.compact};
    margin: 0 auto ${size[24]};

    & > span {
      color: ${theme.palette.primary.mainContrast};
    }

    ${breakpoint.up('smMd')} {
      text-align: center;
      font-size: ${pxToRem(48)};
      font-weight: 600;
      letter-spacing: -1px;
      margin-bottom: ${size[32]};
    }
  }
`

export const desc = (theme: Theme) => css`
  margin-bottom: ${size[24]};
  color: ${theme.palette.text.title};
  line-height: 100%;
  font-size: ${pxToRem(17)};
  font-weight: 300;

  ${breakpoint.up('smMd')} {
    text-align: center;
    font-size: ${pxToRem(24)};
    margin-bottom: ${size[40]};
  }
`

export const container = css`
  margin: ${size[32]} auto 0;
  padding: 0 ${size[20]};
  max-width: ${width.container.wider};

  ${breakpoint.up('smMd')} {
    margin: ${size[56]} auto;
  }
`

export const centered = css`
  text-align: center;
`

export const shopsWrap = css`
  overflow: auto;
  width: 100%;

  ${breakpoint.up('smMd')} {
    display: contents;
  }
`

export const shops = css`
  position: relative;
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: ${size[12]};
  margin-bottom: ${size[32]};
  width: ${width.container.wide};

  ${breakpoint.up('smMd')} {
    gap: ${size[24]};
    width: unset;
    grid-template-rows: initial;
    grid-template-columns: repeat(10, 1fr);
  }
`

export const shopsInCategory = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${size[12]};

  ${breakpoint.up('smMd')} {
    grid-template-columns: repeat(5, 1fr);
    gap: ${size[24]};
  }
`

export const categoryTitle = css`
  font-weight: 700;
  text-transform: capitalize;
`
